import { WebEffects } from './web/web.effects';

export const APP_EFFECTS = [WebEffects];
